import { FeatureNames } from 'owa-mail-smart-pill-features';
import { SmartPillData } from 'owa-smart-pill';

const ONE_PILL: number = 1;
const TWO_PILLS: number = 2;
const THREE_PILLS: number = 3;

export interface SmartPillRenderingStrategy {
    numOfPills: number;
}

// TODO: Add tests. See VSO 46399.
export interface SmartPillRenderingStrategies {
    smartDoc?: SmartPillRenderingStrategy;
    smartTime?: SmartPillRenderingStrategy;
    smartReply?: SmartPillRenderingStrategy;
    smartTodo?: SmartPillRenderingStrategy;
    smartReminder?: SmartPillRenderingStrategy;
}

/**
 * Returns a set of smart-* pills based on feature settings
 * TODO: Clean up this file when getting rid of the old smart reply implementation. VSO 43645
 *
 * @param {SmartPillData[]} pills populated smart data from email props
 * @returns an object indicates which smart-* pills needed to show
 */
export default function getStrategiesForRenderingSmartPills(
    pills: SmartPillData[]
): SmartPillRenderingStrategies {
    /**
     * Priority is:
     * 1. Meeting (with or without smart reply with text)
     * 2. File (with or without smart reply with text)
     * 3. Task (with or without smart reply with text)
     * 4. Smart reply with text
     * Actions (meeting, file, task) are shown at the end, after smart replies (if any)
     */
    if (pills) {
        const hasSmartTimeProps: boolean = pills.some(
            x => x.featureName === FeatureNames.SmartTime
        );
        const hasSmartReplyProps: boolean = pills.some(
            x => x.featureName === FeatureNames.SmartReply
        );
        const hasSmartDocProps: boolean = pills.some(x => x.featureName === FeatureNames.SmartDoc);
        const hasSmartTodoProps: boolean = pills.some(
            x => x.featureName === FeatureNames.SmartTodo
        );
        const hasSmartReminderProps: boolean = pills.some(
            x => x.featureName === FeatureNames.SmartReminder
        );

        if (hasSmartTimeProps) {
            if (hasSmartReplyProps) {
                return {
                    smartReply: {
                        numOfPills: TWO_PILLS,
                    },
                    smartTime: {
                        numOfPills: ONE_PILL,
                    },
                };
            } else {
                return {
                    smartTime: {
                        numOfPills: ONE_PILL,
                    },
                };
            }
        } else if (hasSmartDocProps) {
            if (hasSmartReplyProps) {
                return {
                    smartReply: {
                        numOfPills: TWO_PILLS,
                    },
                    smartDoc: {
                        numOfPills: ONE_PILL,
                    },
                };
            } else {
                return {
                    smartDoc: {
                        numOfPills: ONE_PILL,
                    },
                };
            }
        } else if (hasSmartTodoProps && hasSmartReminderProps) {
            if (hasSmartReplyProps) {
                return {
                    smartTodo: {
                        numOfPills: ONE_PILL,
                    },
                    smartReminder: {
                        numOfPills: ONE_PILL,
                    },
                    smartReply: {
                        numOfPills: ONE_PILL,
                    },
                };
            } else {
                return {
                    smartTodo: {
                        numOfPills: ONE_PILL,
                    },
                    smartReminder: {
                        numOfPills: ONE_PILL,
                    },
                };
            }
        } else if (hasSmartTodoProps) {
            if (hasSmartReplyProps) {
                return {
                    smartTodo: {
                        numOfPills: ONE_PILL,
                    },
                    smartReply: {
                        numOfPills: TWO_PILLS,
                    },
                };
            } else {
                return {
                    smartTodo: {
                        numOfPills: ONE_PILL,
                    },
                };
            }
        } else if (hasSmartReplyProps) {
            return {
                smartReply: {
                    numOfPills: THREE_PILLS,
                },
            };
        }
    }
    return null;
}
